export class PieChartStackData {
    Id: string;
    Name: string;
    Value: number;
    Color: string;
    Path: string;
}